import { useCallback, useContext, useEffect, useState } from 'react';
import { incomingInvoice as incomingInvoiceApi } from 'utilities/api';
import catchCancel from 'helpers/catchCancel';
import { Context } from 'components/Store';
import { parseServerError } from 'helpers/errorHelpers';

const useIncomingInvoiceRetailers = () => {
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useContext(Context);
  const [availableRetailers, setAvailableRetailers] = useState([]);
  const orgId = localStorage.getItem('selectedOrganizationId');

  useEffect(() => {
    async function loadIncomingInvoiceRetailers() {
      const response = await getIncomingInvoiceRetailers();
      if (response?.data?.length > 0) {
        setAvailableRetailers(response.data);
      }
    }

    loadIncomingInvoiceRetailers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getIncomingInvoiceRetailers = useCallback(
    () => {
      const { promise } = incomingInvoiceApi
        .createChildApi({
          action: 'integrations/incoming-invoice/retailer'
        })
        .fetch(null, undefined, {
          headers: {
            'cwf-context': JSON.stringify({
              organization_id: orgId
            })
          }
        });

      setLoading(true);

      return promise
        .then(res => res)
        .catch(catchCancel)
        .catch(parseServerError(dispatch))
        .finally(() => setLoading(false));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [orgId]
  );

  return {
    availableRetailers,
    getIncomingInvoiceRetailers,
    loading
  };
};

export default useIncomingInvoiceRetailers;
